import {
  Input,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import React from "react";
import { updateDecimalInputOnState } from "../../utilities/tp-validations";
import TableStyleUtility from "../TransactionUtility/connected-table-style-utility-bar";

function LeaseAccordion(props) {
  const compBids = parseInt(props.transactions.compBids, 10);

  return (
    <TableContainer variant="outlined">
      <Table
        striped
        sx={{ minWidth: 650 }}
        aria-label="simple table"
        size={"small"}
      >
        <TableStyleUtility />
        <TableBody>
          <TableRow
            hover
            key="Monthly Lease Payment"
            id={"Monthly Lease Payment"}
          >
            <TableCell>
              <InputLabel>{props.texts.MON_LEASE_PAY}</InputLabel>
            </TableCell>
            <TableCell align="center">
              <Input
                type={"text"}
                fullWidth
                id="jdMonthlyLeasePayment"
                readOnly={props.actionType.action === "view"}
                value={
                  props.transactions.bids[0].paymentType.monthlyPayment
                }
                onChange={(e) => {
                  updateDecimalInputOnState(
                    e.target.value,
                    8,
                    "monthlyPayment",
                    "JD",
                    props.setBidsPaymentTypeTextValue
                  );
                  props.calculateSpreadAndMargin(props);
                }}
              />
            </TableCell>
            {Array(compBids)
              .fill(null)
              .map((value, index) => (
                <TableCell align="center">
                  <Input
                    type={"text"}
                    fullWidth
                    id="compMonthlyLeasePayment"
                    readOnly={props.actionType.action === "view"}
                    value={
                      props.transactions.bids[index + 1].paymentType
                        .monthlyPayment
                    }
                    onChange={(e) => {
                      updateDecimalInputOnState(
                        e.target.value,
                        8,
                        "monthlyPayment",
                        `C${index + 1}`,
                        props.setBidsPaymentTypeTextValue
                      );
                      props.calculateSpreadAndMargin(props);
                    }}
                  />
                </TableCell>
              ))}
          </TableRow>

          <TableRow hover key="Months Leased" id={"Months Leased"}>
            <TableCell>
              <InputLabel>{props.texts.MON_LEASED}</InputLabel>
            </TableCell>
            <TableCell align="center">
              <Input
                type={"text"}
                fullWidth
                id="jdMonthLeased"
                readOnly={props.actionType.action === "view"}
                value={
                  props.transactions.bids[0].paymentType.noOfMonths
                }
                onChange={(e) => {
                  if (e.target.value.match("^[\\d]*$")) {
                    updateDecimalInputOnState(
                      e.target.value,
                      2,
                      "noOfMonths",
                      "JD",
                      props.setBidsPaymentTypeTextValue
                    );
                  }
                  props.calculateSpreadAndMargin(props);
                }}
              />
            </TableCell>
            {Array(compBids)
              .fill(null)
              .map((value, index) => (
                <TableCell align="center">
                  <Input
                    type={"text"}
                    fullWidth
                    id="compMonthLeased"
                    readOnly={props.actionType.action === "view"}
                    value={
                      props.transactions.bids[index + 1].paymentType
                        .noOfMonths
                    }
                    onChange={(e) => {
                      if (e.target.value.match("^[\\d]*$")) {
                        updateDecimalInputOnState(
                          e.target.value,
                          2,
                          "noOfMonths",
                          `C${index + 1}`,
                          props.setBidsPaymentTypeTextValue
                        );
                      }
                      props.calculateSpreadAndMargin(props);
                    }}
                  />
                </TableCell>
              ))}
          </TableRow>
          <TableRow hover key="Purchase Opt Amt." id={"Purchase Opt Amt."}>
            <TableCell>
              <InputLabel>{props.texts.PURCHASE_OPT_AMT}</InputLabel>
            </TableCell>
            <TableCell align="center">
              <Input
                type={"text"}
                fullWidth
                id="jdPurchaseOptAmt"
                readOnly={props.actionType.action === "view"}
                value={
                  props.transactions.bids[0].paymentType.purchOptAmt
                }
                onChange={(e) => {
                  updateDecimalInputOnState(
                    e.target.value,
                    8,
                    "purchOptAmt",
                    "JD",
                    props.setBidsPaymentTypeTextValue
                  );
                  props.calculateSpreadAndMargin(props);
                }}
              />
            </TableCell>
            {Array(compBids)
              .fill(null)
              .map((value, index) => (
                <TableCell align="center">
                  <Input
                    type={"text"}
                    fullWidth
                    id="compPurchaseOptAmt"
                    readOnly={props.actionType.action === "view"}
                    value={
                      props.transactions.bids[index + 1].paymentType
                        .purchOptAmt
                    }
                    onChange={(e) => {
                      updateDecimalInputOnState(
                        e.target.value,
                        8,
                        "purchOptAmt",
                        `C${index + 1}`,
                        props.setBidsPaymentTypeTextValue
                      );
                      props.calculateSpreadAndMargin(props);
                    }}
                  />
                </TableCell>
              ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default LeaseAccordion;
